import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  class: "logout-content",
  style: {"flex-direction":"column","align-items":"center","justify-content":"center"}
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { style: {"padding-bottom":"6px","color":"#333"} }
const _hoisted_4 = {
  style: {"display":"flex"},
  role: "form"
}
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogFrame = _resolveComponent("DialogFrame")!

  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(_component_DialogFrame, {
        key: 0,
        onClickBackground: _ctx.close
      }, {
        default: _withCtx(() => [
          _createElementVNode("button", {
            class: "close",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }, "×"),
          _createElementVNode("div", _hoisted_1, [
            (_ctx.$root.account.isLogin)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$root.account.info.userName) + "としてログイン中です。 ", 1),
                  _cache[6] || (_cache[6] = _createElementVNode("h4", { class: "title" }, "ログアウトしますか？", -1)),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("button", {
                      id: "focusOnOpen",
                      class: "btn btn-primary",
                      style: {"margin-left":"auto","margin-right":"10px"},
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                    }, _cache[4] || (_cache[4] = [
                      _createElementVNode("span", null, "ログアウト", -1)
                    ])),
                    _createElementVNode("button", {
                      class: "btn btn-outline-primary",
                      style: {"margin-right":"auto","width":"initial"},
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                    }, _cache[5] || (_cache[5] = [
                      _createElementVNode("span", null, "キャンセル", -1)
                    ]))
                  ])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _cache[8] || (_cache[8] = _createElementVNode("h5", {
                    class: "title",
                    style: {"margin":"20px 40px 6px","word-break":"keep-all"}
                  }, "ログインしていません。", -1)),
                  _createElementVNode("button", {
                    id: "focusOnOpen",
                    class: "btn btn-primary",
                    style: {"margin":"1rem 2rem"},
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
                  }, _cache[7] || (_cache[7] = [
                    _createElementVNode("span", null, "閉じる", -1)
                  ]))
                ]))
          ])
        ]),
        _: 1
      }, 8, ["onClickBackground"]))
    : _createCommentVNode("", true)
}